import React from "react";

const ColorPickerAdd = ({ addBgColor, keyName }) => {
  return (
    <div
      className="d-flex align-items-center justify-content-center rounded-circle"
      style={{
        cursor: "pointer",
        width: "20px",
        height: "20px",
        backgroundColor: "#0d6efd",
      }}
      onClick={() => (keyName ? addBgColor(keyName) : addBgColor())}
    >
      <i
        className="bx bx-plus"
        style={{
          fontSize: "14px",
          color: "#fff",
        }}
      />
    </div>
  );
};

export default ColorPickerAdd;
